import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';

@Component({
  selector: 'ngx-json-editor',
  templateUrl: './json-editor.component.html',
  styleUrls: ['./json-editor.component.scss']
})
export class DynamicJsonEditorComponent implements OnInit {

  public editorOptions: JsonEditorOptions;

  @Input('jsonValue') public jsonValue: any;
  @Input('readonly') public readonly: boolean = false;
  @Output() public updated: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(JsonEditorComponent, { static: false }) editor: JsonEditorComponent;

  constructor() {}

  ngOnInit(): void {
    let editorOptions = new JsonEditorOptions();
    editorOptions.mode = 'code'; //set only one mode
    editorOptions.enableSort = false;
    editorOptions.enableTransform = false;
    editorOptions.expandAll = false;

    if (this.readonly) {
      editorOptions.navigationBar = !this.readonly;
    }

    this.editorOptions = editorOptions;
  }

  isValid(): boolean {
    return this.editor.isValidJson()
  }

  getJson(): any {
    return this.editor.get();
  }

}
